import React, { useState } from 'react';
import AdminLayout from './admin/AdminLayout';
import UserManagement from './admin/UserManagement';
import AdminMessaging from './admin/AdminMessaging';
import AdminAuditLog from './admin/AdminAuditLog';

type AdminTab = 'users' | 'messaging' | 'audit';

const AdminPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<AdminTab>('users');

    return (
        <AdminLayout activeTab={activeTab} onTabChange={setActiveTab}>
            {activeTab === 'users' && <UserManagement />}
            {activeTab === 'messaging' && <AdminMessaging />}
            {activeTab === 'audit' && <AdminAuditLog />}
        </AdminLayout>
    );
};

export default AdminPage;
